import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { useActiveProfile } from "app/providers/ActiveProfileProvider";
import { useActiveCustomerAccount } from "app/providers/ActiveCustomerAccountProvider";

export default function BusinessRouteGuard(props: PropsWithChildren) {
  const activeProfile = useActiveProfile();
  const activeCustomerAccount = useActiveCustomerAccount();

  if (activeCustomerAccount || activeProfile?.profile_type !== "business") {
    return <Navigate to="/" replace />;
  }

  return <>{props.children}</>;
}
